export const changeOfAnnualConsumptionSchema = {
  title: 'Change Annual Consumption',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    notification_efd: {
      type: 'string',
      format: 'date-time',
      title: 'Notification Effective From Date',
    },
    notification_expiry: {
      type: 'string',
      format: 'date-time',
      title: 'Notification Expiry Date',
    },
    annual_consumption: {
      type: 'number',
      title: 'Annual Consumption',
    },
    additional_information: {
      type: 'string',
      title: 'Additional Information',
    },
  },
  required: ['mpan_core', 'notification_efd', 'annual_consumption'],
};

export const changeOfAnnualConsumptionUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
  },
  notification_efd: {
    'ui:widget': 'datetime',
    'ui:placeholder': 'Select effective from date and time',
  },
  notification_expiry: {
    'ui:widget': 'datetime',
    'ui:placeholder': 'Select expiry date and time (optional)',
  },
  annual_consumption: {
    'ui:placeholder': 'Enter consumption (e.g., 55.123)',
    'ui:help': 'Must have exactly 3 decimal places',
  },
  additional_information: {
    'ui:widget': 'textarea',
    'ui:placeholder': 'Optional additional information',
  },
};
